export const events = {
  copyShareableKudosUrl: 'Copies shareable kudos URL',
  clickShareOnLinkedin: 'Clicks share to linkedin CTA',
  clickViewKudosPage: 'Clicks view kudos page CTA',
  createsKudos: 'Creates kudos',
}
